/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable simple-import-sort/exports */
import React from 'react';
import { styled } from '@mui/material/styles';
import useAutocomplete from '@mui/material/useAutocomplete';
import CheckIcon from '@mui/icons-material/Check';
import SearchIcon from 'components/Icons/SearchIcon';
import ProfileIcon from 'components/Icons/ProfileIcon';
import { autocompleteClasses } from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import GroupProfile from '../../assets/Images/GroupProfile.svg';

// Styled Components
const Root = styled('div')(
  ({ theme }) => `
  color: ${
    theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,.85)'
  };
  font-size: 14px;
`
);

const InputWrapper = styled('div')(
  ({ theme }) => `
  width: 300px;
  border: 1px solid ${theme.palette.mode === 'dark' ? '#434343' : '#d9d9d9'};
  background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
  }

  &.focused {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
    color: ${
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.65)'
        : 'rgba(0,0,0,.85)'
    };
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 5px;
    outline: 0;
  }
`
);

const Listbox = styled('ul')(
  ({ theme }) => `
  width: 300px;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;

  & li {
    padding: 5px 12px;
    display: flex;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected='true'] {
    background-color: ${theme.palette.mode === 'dark' ? '#2b2b2b' : '#fafafa'};
    font-weight: 500;

    & svg {
      color: #088AB2;
    }
  }

  & li.${autocompleteClasses.focused} {
    background-color: ${theme.palette.mode === 'dark' ? '#003b57' : '#e6f7ff'};
    cursor: pointer;

    & svg {
      color: currentColor;
    }
  }
`
);

// Component Definition
export default function SingleSelectComponent({
  data,
  handleValue,
  handleEventValue,
}: any) {
  const [selectedOption, setSelectedOption] = React.useState<any>(null);
  const { t } = useTranslation('group');
  const location = useLocation();

  const {
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    id: 'single-select-demo',
    options: data,
    getOptionLabel: (option: any) => option?.name,
    filterOptions: (options, state) => {
      const inputValue = state.inputValue.toLowerCase();
      return options.filter(
        (option: any) =>
          option?.title?.toLowerCase().includes(inputValue) &&
          (!selectedOption || selectedOption.title !== option.title)
      );
    },
    onChange: (_, value: any) => {
      setSelectedOption(value);
    },
    disableCloseOnSelect: true, // Ensure single selection
  });

  React.useEffect(() => {
    handleValue(selectedOption);
  }, [selectedOption]);

  const getImage = (option: any) => {
    if (option.image) {
      return <img src={option.image} alt="" className="h-8 w-8 rounded-full" />;
    }
    if (option.group) {
      return (
        <img
          src={GroupProfile}
          alt="Group Profile"
          className="h-[40px] w-[40px] rounded-full"
        />
      );
    }
    return <ProfileIcon />;
  };

  return (
    <Root>
      <div {...getRootProps()} className="flex items-center">
        <InputWrapper
          ref={setAnchorEl}
          className={
            focused
              ? 'focused h-auto w-full rounded-lg'
              : 'h-auto w-full rounded-lg'
          }
          style={{ display: 'flex', alignItems: 'center' }}
          onChange={(e: any) => handleEventValue(e.target.value)}
        >
          <div className="p-1.5 py-3 pl-3">
            <SearchIcon />
          </div>
          <input
            {...getInputProps()}
            placeholder={t('Search') as string}
            className="number_input"
          />
        </InputWrapper>
      </div>
      {groupedOptions.length > 0 && (
        <Listbox
          {...getListboxProps()}
          className={`w-[84%] ${
            location.pathname === '/chat' ? 'sm:w-[400px]' : 'sm:w-[555px]'
          }`}
        >
          {(groupedOptions as typeof data).map((option: any, index: number) => (
            <li
              {...getOptionProps({ option, index })}
              className={`m-1 flex h-[52px] w-[84%] items-center bg-[#F9FAFB] ${
                location.pathname === '/chat' ? 'sm:w-[370px]' : 'sm:w-[520px]'
              }`}
              key={option.title}
            >
              {getImage(option)}
              <div className="w-auto">
                <span className="pl-2 text-md font-medium not-italic text-secondary-100 ">
                  {option.name}
                </span>
              </div>
              <span className="p-2 text-gray-600">{option.code}</span>
              <CheckIcon fontSize="small" />
            </li>
          ))}
        </Listbox>
      )}
    </Root>
  );
}
